<template>
  <v-icon
    v-bind="$attrs"
    :size="computedSize"
    :color="computedColor"
    class="ds-icon"
  >
    <slot />
  </v-icon>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ICON_SIZES } from '@/shared/tokens'

export interface DsIconProps {
  /**
   * Tamaño del icono según el sistema de diseño
   * @default 'md'
   */
  dsSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  /**
   * Color del icono según el sistema de diseño
   */
  dsColor?: 'primary' | 'accent' | 'success' | 'error' | 'warning' | 'info' | 'gray'
}

const props = withDefaults(defineProps<DsIconProps>(), {
  dsSize: 'md'
})

const computedSize = computed(() => {
  // Convertir rem a número para Vuetify
  const sizeInRem = ICON_SIZES[props.dsSize]
  return sizeInRem
})

const computedColor = computed(() => {
  if (!props.dsColor) return undefined

  switch (props.dsColor) {
    case 'accent':
      return 'accent'
    case 'success':
      return 'success'
    case 'error':
      return 'error'
    case 'warning':
      return 'warning'
    case 'info':
      return 'info'
    case 'gray':
      return 'gray-600'
    default:
      return 'primary'
  }
})
</script>

<style scoped lang="scss">
.ds-icon {
  // Los estilos base están definidos en los defaults de Vuetify
}
</style>
